













import { Vue, CombineQrReader } from 'saiten-base';
import { Component, Prop, Watch, SaitenState, ConstsState, DmShareds, Modal } from 'saiten-base';

@Component({components: {CombineQrReader, Modal}, mixins:[]})
export default class PhotoStudyQRTaken extends Vue {
  modal_message: string | null = null

  onDecode(content: string) {
    const modal = this.$refs.myModalRef as Modal;
    // QRからsheetを取得
    //console.log(`upload/${content}`)
    DmShareds.Http.get(`./api/study/sheet_by_qr`, {params:{qr:content}})
      .then((res: any) => {
        // console.log(res.data)
        if(res.data.result == "ok"){
          if(res.data.page == 0){
            let sheet = res.data.sheet
            this.$router.push(`take/${sheet.id}/0`)
          }else{
            this.modal_message = `二次元バーコードエラー。1ページ目のQRを読み取ってください。二次元バーコード値[${content}]。`;
            modal.show()
          }
        }else{
          this.modal_message = res.data.message
          modal.show()
        }
      }, (err: any) => {
        this.modal_message = `二次元バーコードエラーが発生しました。二次元バーコード値[${content}]を確認してください。`;
        modal.show()
      })
  }
  go_hidden(){
    // ダイアログ非表示時、リロード
    location.reload()
  }
}

